import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import {
    GetCompanyConfigQuery,
    GetCompanyConfigDocument,
} from '@graphql/generated/graphql';

import {
    sanitizeStoryConfig,
    StoryRenderOptions,
    AdditionalProductRenderOptions,
    sanitizeAdditionalProductConfig,
    sanitizeWhiteLabelConfig,
    WhiteLabelConfig,
    AdsOptions,
    sanitizeAdsConfig,
    CtaConfig,
    sanitizeCtaConfig,
} from './featureConfig';
import { CompanyTheme } from '../uikit/theme/types';

export type CompanyConfig = {
    companyTheme: CompanyTheme;
    companyCustomHead: string;
    whiteLabel: WhiteLabelConfig;
    story: StoryRenderOptions;
    additionalProduct: AdditionalProductRenderOptions;
    ads: AdsOptions;
    cta: CtaConfig;
};

export const buildCompanyConfig = (
    data?: GetCompanyConfigQuery
): CompanyConfig => {
    const company = data?.companies?.[0];
    return {
        companyTheme: (company?.CustomTheme as CompanyTheme) || {},
        companyCustomHead: company?.CustomHead || '',
        whiteLabel: sanitizeWhiteLabelConfig(company?.Config?.whiteLabel),
        story: sanitizeStoryConfig(company?.Config?.story),
        additionalProduct: sanitizeAdditionalProductConfig(
            company?.Config?.additionalProduct
        ),
        ads: sanitizeAdsConfig(company?.Config?.ads),
        cta: sanitizeCtaConfig(company?.Config?.cta),
    };
};

export const getCompanyConfig = async (
    client: ApolloClient<NormalizedCacheObject>,
    companySlug: string,
    locale: string
): Promise<CompanyConfig> => {
    const { data } = await client.query<GetCompanyConfigQuery>({
        query: GetCompanyConfigDocument,
        variables: { locale, slug: companySlug },
    });
    return buildCompanyConfig(data);
};
